import React, { type FC, type ReactNode, type SyntheticEvent } from 'react';
import classnames from 'classnames';
import { Tab, Tabs } from '@mui/material';

import styles from 'theme/pages/wise/WiseProduct/components/WiseProductTabs/WiseProductTabs.module.scss';

export type WiseProductTabItem = {
  value: string | number;
  label: ReactNode;
};

export type WiseProductTabsProps = {
  items: WiseProductTabItem[];
  value: string | number;
  onChange: (event: SyntheticEvent, value: string | number) => void;
  className?: string;
};

const WiseProductTabs: FC<WiseProductTabsProps> = ({ items, value, onChange, className }) => (
  <div
    className={classnames(
      styles.root,
      className,
      'StylePath-Pages-Wise-WiseProduct-components-WiseProductTabs'
    )}>
    <Tabs
      value={value}
      onChange={onChange}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      classes={{
        root: styles.tabsRoot,
        indicator: styles.indicator
      }}>
      {items.map((item) => (
        <Tab
          key={item.value}
          label={item.label}
          value={item.value}
          disableRipple
          classes={{ root: styles.tabRoot }}
        />
      ))}
    </Tabs>
  </div>
);

export default WiseProductTabs;
